module.exports = __webpack_public_path__ + "dingbeauty-landing/img/icon_i01.2f07bc00.svg";